// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// The user's own WaniKani personal access token, which they type in
// themselves - kept in localStorage (not sessionStorage) so the connection
// persists across visits. That means it's readable by any script that gets
// to run on this origin (e.g. an XSS bug), same as any other localStorage
// value here; there's nothing more sensitive than the user's own site
// content to steal alongside it today, but keep that tradeoff in mind
// before storing anything more sensitive the same way.
const TOKEN_KEY = "kanalearn.wanikani.token";
const CACHE_KEY = "kanalearn.wanikani.cache.v1";

// Subjects (kanji metadata: character, level) rarely change, so they're only
// refetched occasionally rather than on every visit.
export const SUBJECTS_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || null;
    } catch {
        return null;
    }
}

export function setToken(token) {
    try {
        localStorage.setItem(TOKEN_KEY, token);
    } catch {
        // Best-effort: if storage is unavailable, the connection just won't persist.
    }
}

export function clearToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        // Ignore.
    }
}

export function getCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function setCache(cache) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch {
        // Best-effort: a full/unavailable storage just means no caching this session.
    }
}

export function clearCache() {
    try {
        localStorage.removeItem(CACHE_KEY);
    } catch {
        // Ignore.
    }
}

export function isSubjectsCacheStale(subjectsFetchedAt) {
    if (!subjectsFetchedAt) return true;
    return Date.now() - subjectsFetchedAt > SUBJECTS_MAX_AGE_MS;
}
